import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { errorToast, isAdmin, successToast } from "../../api/Util";
import { Redirect } from "react-router-dom";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Container,
  Icon,
  Row,
  Textarea,
  TextInput,
  Select,
} from "react-materialize";
import { axiosClient } from "../../api/httpClient";
import {
  deleteSpacesObjectByPublicUrl,
  isDigitalOceanSpacesUrl,
  uploadMedia,
} from "../../api/Util";
import * as actions from "../../actions";
import PageHeader from "../TopHeader/PageHeader";
import "react-datepicker/dist/react-datepicker.css";
import AnnouncmentTable from "../AnnouncementTable/AnnouncementTable";
import styles from "./Settings.module.scss";
import "./Settings.scss";

const SETTINGS_DEFAULT = {
  enable_banner: false,
  banner_heading: "",
  banner_heading_style: "h4",
  banner_text: "",
  banner_text_style: "15px",
  banner_heading_color: "#ffffff",
  banner_font_style: "none",
  banner_image: "",
  banner_image_style_height: "",
  banner_image_style_width: "",
  startDate: "",
  endDate: "",
};
const FontStyles = [
  { name: "Normal", value: "none" },
  { name: "Bold", value: "b" },
  { name: "Italics", value: "i" },
];

const Settings = ({ auth, settings }) => {
  const [editData, setEditedData] = useState({});
  const [deleteId, setDeleteId] = useState();
  const [state, setState] = useState(SETTINGS_DEFAULT);
  const [color, setColor] = useState(SETTINGS_DEFAULT.banner_heading_color);
  const [allSettingsData, setAllSettingsData] = useState([]);
  const [activateDeactive, setActivateDeactivate] = useState(null);
  const [isUploadingBanner, setIsUploadingBanner] = useState(false);
  const [bannerUploadProgress, setBannerUploadProgress] = useState(0);
  const [bannerFileInputKey, setBannerFileInputKey] = useState(0);
  const [bannerImageLoaded, setBannerImageLoaded] = useState(false);
  const [bannerImageSource, setBannerImageSource] = useState(null);

  useEffect(() => {
    fetchAllSettings();
  }, []);

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setState(editData);
      setColor(editData.banner_heading_color || SETTINGS_DEFAULT.banner_heading_color);
      const bannerUrl = (editData.banner_image || "").trim();
      if (bannerUrl && isDigitalOceanSpacesUrl(bannerUrl)) {
        setBannerImageSource("upload");
      } else if (bannerUrl) {
        setBannerImageSource("url");
      } else {
        setBannerImageSource(null);
      }
    } else {
      setState(SETTINGS_DEFAULT);
      setColor(SETTINGS_DEFAULT.banner_heading_color);
      setBannerImageSource(null);
    }
  }, [editData]);

  useEffect(() => {
    setBannerImageLoaded(false);
  }, [state?.banner_image]);

  useEffect(() => {
    if (deleteId) {
      deleteSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteId]);

  useEffect(() => {
    if (activateDeactive) {
      editSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activateDeactive]);

  if (!isAdmin(auth?.loggedInUser)) {
    return <Redirect to="/" />;
  }

  function buildBannerImageStyleFromState(localState) {
    const parts = [];
    if (localState?.banner_image_style_height) {
      parts.push(`height: ${localState.banner_image_style_height}px`);
    }
    if (localState?.banner_image_style_width) {
      parts.push(`width: ${localState.banner_image_style_width}px`);
    }
    parts.push("max-width: 100%");
    parts.push("max-height: 600px");
    parts.push("object-fit: contain");
    parts.push("display: block");
    parts.push("margin: 0 auto");
    return parts.join("; ");
  }

  function saveSettings() {
    const banner_image_style = buildBannerImageStyleFromState(state);
    let body = {
      ...state,
      enable_banner: state.enable_banner ? 1 : 0,
      banner_heading_color: color,
      banner_image_style,
      banner_image: (state.banner_image || "").trim(),
    };
    axiosClient
      .put(`/api/portal/settings/V2`, body)
      .then(({ data }) => {
        successToast(data.message || "Settings updated");
        fetchAllSettings();
        setState(SETTINGS_DEFAULT);
        setColor(SETTINGS_DEFAULT.banner_heading_color);
        setBannerImageSource(null);
        setDeleteId(null);
        setEditedData({});
      })
      .catch((err) => {
        errorToast("Something went wrong");
      });
  }

  function deleteSettings() {
    if (deleteId) {
      const toDelete = (allSettingsData || []).find((item) => item.id === deleteId);
      const bannerImageUrl = toDelete?.banner_image;

      axiosClient
        .delete(`/api/portal/settings/V2/${deleteId}/deleteAnnouncment`)
        .then(({ data }) => {
          successToast(data.message || "Announcement deleted");
          if (bannerImageUrl && isDigitalOceanSpacesUrl(bannerImageUrl)) {
            deleteSpacesObjectByPublicUrl(bannerImageUrl);
          }
          fetchAllSettings();
          setDeleteId(null);
        })
        .catch((err) => {
          errorToast("Something went wrong");
        });
    }
  }

  function editSettings() {
    let body;
    if (editData && Object.keys(editData).length > 0) {
      body = { ...state };
    } else if (activateDeactive) {
      body = { ...activateDeactive };
    } else {
      return;
    }

    body.banner_image_style = buildBannerImageStyleFromState(body);
    body.banner_image = (body.banner_image || "").trim();

    axiosClient
      .post(`/api/portal/update-settings/V2/${body.id}`, body)
      .then(({ data }) => {
        successToast(data.message || "Settings updated");
        fetchAllSettings();
        setState(SETTINGS_DEFAULT);
        setColor(SETTINGS_DEFAULT.banner_heading_color);
        setBannerImageSource(null);
        setDeleteId(null);
        setEditedData({});
        setActivateDeactivate(null);
      })
      .catch((err) => {
        errorToast("Something went wrong");
      });
  }

  function fetchAllSettings() {
    axiosClient
      .get("/api/portal/settings/V2")
      .then(({ data }) => {
        setAllSettingsData(data);
      })
      .catch((err) => {
        errorToast("Something went wrong");
      });
  }

  function onChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (e.target.type === "checkbox") {
      setState((prevState) => ({ ...prevState, [name]: !prevState[name] }));
    } else {
      setState((prevState) => ({ ...prevState, [name]: value }));
    }
  }

  const handleBannerImageUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    if (!file.type || !file.type.startsWith("image/")) {
      errorToast("Please select a valid image file");
      return;
    }

    const clientId = auth?.loggedInUser?.client_id;
    if (!clientId) {
      errorToast("Unable to determine client for upload");
      return;
    }

    if (state.banner_image && bannerImageSource === "upload") {
      deleteSpacesObjectByPublicUrl(state.banner_image);
    }

    setIsUploadingBanner(true);
    setBannerUploadProgress(0);

    try {
      const url = await uploadMedia(file, clientId, null, "media/portal-banners");

      if (!url) {
        errorToast("Unable to determine uploaded image URL");
        return;
      }

      setBannerUploadProgress(100);
      setBannerImageSource("upload");
      setState((prev) => ({
        ...prev,
        banner_image: url,
      }));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      errorToast("Something went wrong while uploading image");
    } finally {
      setIsUploadingBanner(false);
    }
  };

  const handleRemoveBannerImage = () => {
    if (state.banner_image && bannerImageSource === "upload") {
      deleteSpacesObjectByPublicUrl(state.banner_image);
    }
    setBannerImageSource(null);
    setState((prev) => ({
      ...prev,
      banner_image: "",
    }));
    setBannerFileInputKey((prev) => prev + 1);
  };

  const handleBannerImageUrlChange = (e) => {
    const value = e.target.value;
    setBannerImageSource(value.trim() ? "url" : null);
    setState((prev) => ({
      ...prev,
      banner_image: value,
    }));
    if (value.trim()) {
      setBannerFileInputKey((prev) => prev + 1);
    }
  };

  return (
    <Row className="settings-main">
      <PageHeader title="Settings" />
      <Container className="toolBoxCustom">
        <Card
              title="Admin Portal Settings"
              className="announcementsForm"
              actions={[
                <Button
                  key="save-btn"
                  className="btn-primary saveButton"
                  icon={<Icon left>save</Icon>}
                  onClick={
                    editData && Object.keys(editData).length === 0
                      ? saveSettings
                      : editSettings
                  }
                  disabled={
                    !state.banner_heading ||
                    !state.banner_text ||
                    !state.startDate ||
                    !state.endDate
                  }
                >
                  {editData && Object.keys(editData).length === 0 ? "Save" : "Update"}
                </Button>,
              ]}
            >
        <Container>
          <Row style={{ display: "flex", flexDirection: "column" }}>
            <Col s={12}>
              <Icon left>visibility_off</Icon>
              <Checkbox
                name="enable_banner"
                id="check-enable_banner"
                value="1"
                label="Enable Announcement"
                onChange={onChange}
                checked={state?.enable_banner}
              />
            </Col>
            <div
              style={{
                display: "flex",
                alignItems: "stretch",
                flexWrap: "wrap",
              }}
            >
              <div className={styles.headingStyle}>
                <TextInput
                  s={7}
                  id="txt_bh"
                  name="banner_heading"
                  label="Heading"
                  onChange={onChange}
                  className={styles.commonFormInputStyle}
                  value={state?.banner_heading}
                />
                <Select
                  s={3}
                  id="txt_bhs"
                  name="banner_heading_style"
                  label="Heading Type"
                  value={state?.banner_heading_style}
                  className={styles.commonFormInputStyle}
                  onChange={onChange}
                >
                  {[...Array(6).keys()].map((index) => (
                    <option key={index} value={`h${index + 1}`}>
                      H{index + 1} {index + 1 === 4 ? " (Recommended)" : null}
                    </option>
                  ))}
                </Select>
                <div className={`${styles.colorPicker} colorPickerDiv`}>
                  <TextInput
                    s={2}
                    id="color"
                    name="banner_heading_color"
                    style={{ width: "100%" }}
                    type="color"
                    label="Heading Style"
                    className={styles.commonFormInputStyle}
                    onChange={(e) => {
                      setColor(e.target.value);
                      onChange(e);
                    }}
                  />{" "}
                </div>
              </div>
              <div className={styles.bodyTextAreaStyle}>
                <Textarea
                  s={7}
                  id="txt_bt"
                  name="banner_text"
                  label="Body"
                  value={state?.banner_text}
                  className={styles.commonFormInputStyle}
                  onChange={onChange}
                />
                <Select
                  s={3}
                  id="txt_bts"
                  name="banner_text_style"
                  className={styles.commonFormInputStyle}
                  label="Body Style"
                  value={state?.banner_text_style}
                  onChange={onChange}
                >
                  {[...Array(7).keys()].map((index) => (
                    <option key={index} value={`${14 + index}px`}>
                      {14 + index}px{" "}
                      {14 + index === 15 ? " (Recommended)" : null}
                    </option>
                  ))}
                </Select>
                <Select
                  s={2}
                  id="txt_bhs"
                  name="banner_font_style"
                  value={state?.banner_font_style}
                  className={styles.commonFormInputStyle}
                  label="Font Style"
                  onChange={onChange}
                >
                  {FontStyles.map((fontStyle, index) => (
                    <option key={index} value={fontStyle.value}>
                      {fontStyle.name}
                    </option>
                  ))}
                </Select>
              </div>
              <TextInput
                s={3}
                id="txt_bi"
                key={bannerFileInputKey}
                type="file"
                disabled={isUploadingBanner}
                accept="image/*"
                label="Banner Image (upload)"
                className={styles.commonFormInputStyle}
                onChange={handleBannerImageUpload}
              />
              <Col s={1} className={styles.bannerImageOrCol}>
                <span className={styles.bannerImageOr}>OR</span>
              </Col>
              <TextInput
                s={3}
                id="txt_banner_url"
                type="text"
                label="External Image URL"
                className={styles.commonFormInputStyle}
                value={(bannerImageSource === "url" || bannerImageSource === null) && state?.banner_image != null ? state.banner_image : ""}
                onChange={handleBannerImageUrlChange}
              />
              <TextInput
                s={3}
                id="txt_bis_height"
                name="banner_image_style_height"
                value={state?.banner_image_style_height}
                className={styles.commonFormInputStyle}
                type="number"
                label="Image Style(Height in Pixel)"
                onChange={onChange}
              />
              <TextInput
                s={2}
                id="txt_bis_width"
                name="banner_image_style_width"
                value={state?.banner_image_style_width}
                className={styles.commonFormInputStyle}
                type="number"
                label="Image Style(Width in Pixel)"
                onChange={onChange}
              />
              {isUploadingBanner && (
                <Col s={12}>
                  <span className={styles.bannerUploadStatus}>
                    Uploading... {bannerUploadProgress}%
                  </span>
                </Col>
              )}
              {state?.banner_image?.trim() && (
                <Col s={12} className={styles.bannerImagePreviewCol}>
                  <div className={styles.bannerImageWrapper}>
                    <img
                      key={state.banner_image.trim()}
                      src={state.banner_image.trim()}
                      alt="Banner preview"
                      className={styles.bannerImage}
                      onLoad={() => setBannerImageLoaded(true)}
                      onError={() => setBannerImageLoaded(true)}
                    />
                    {bannerImageLoaded && (
                      <button
                        type="button"
                        onClick={handleRemoveBannerImage}
                        title="Remove image"
                        aria-label="Remove image"
                        className={styles.bannerImageRemoveButton}
                      >
                        <Icon tiny className={styles.bannerImageRemoveIcon}>
                          close
                        </Icon>
                      </button>
                    )}
                  </div>
                </Col>
              )}
              <div className={styles.startAndEndDateDiv}>
                <TextInput
                  s={4}
                  id="start_date"
                  name="startDate"
                  label="Start Date"
                  value={state?.startDate}
                  className={styles.commonFormInputStyle}
                  onChange={onChange}
                  type="date"
                />
                <TextInput
                  s={4}
                  id="end_date"
                  name="endDate"
                  label="End Date"
                  value={state?.endDate}
                  className={styles.commonFormInputStyle}
                  onChange={onChange}
                  type="date"
                />
              </div>
            </div>
          </Row>
        </Container>
      </Card>
        <Card className="announcementsListTable">
          <AnnouncmentTable
            settingsData={allSettingsData}
            setEditedData={setEditedData}
            setDeleteId={setDeleteId}
            setActivateDeactivate={setActivateDeactivate}
          />
        </Card>
      </Container>
    </Row>
  );
};

function mapStateToProps({ auth, settings }) {
  return { auth, settings };
}

export default connect(mapStateToProps, actions)(Settings);
